import script from "./merge.vue?vue&type=script&lang=ts&setup=true"
export * from "./merge.vue?vue&type=script&lang=ts&setup=true"

import "./merge.vue?vue&type=style&index=0&id=3dc4116e&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc4116e"]])

export default __exports__